import React from "react";
import classes from "./styles.module.scss";
import { Typography } from "antd";
import DecisionComparisonChart from "./DecisionComparisonChart";

const { Title, Text } = Typography;

const DecisionComparison = () => {
  return (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Decision Comparison
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Compare the decisions made by different users in the same scenario.
        </Text>
      </div>
      <div style={{ marginTop: 20 }}>
        <DecisionComparisonChart />
      </div>
    </>
  );
};
export default DecisionComparison;
